<template>
    <div class="w-full px-6 mt-6">
        <div class="text-xs text-secondary font-medium tracking-wide">
            Results: {{ isLoaded ? total : "..." }}
        </div>
        <div class="flex mt-4">
            <!-- Filter Button -->
            <div class="flex-grow">
                <div
                    class="
                        mx-1
                        mb-2
                        px-4
                        py-2
                        w-max
                        rounded-full
                        text-xs text-secondary-light text-white
                        font-medium
                        tracking-wide
                        bg-secondary-light
                    "
                    @click="selectFilter"
                >
                    <i class="icon-np-tune"></i>
                    Filter
                    <span v-if="filterLength > 0"> ({{ filterLength }}) </span>
                </div>
            </div>

            <!-- Sort -->
            <sort-component
                :originalSort="originalSort"
                @sort="sort"
                class="mt-1"
            ></sort-component>
        </div>

        <!-- Selected Filters -->
        <selected-filter-component
            v-show="keyword || filter"
            :keyword="keyword"
            :filter="originalFilter"
            :compoundlist="compoundList"
            :minPrice="minPrice"
            :maxPrice="maxPrice"
            :minYear="minYear"
            :maxYear="maxYear"
            :showLabel="false"
            :labelColor="'bg-white'"
            @remove="remove"
            class="mt-1"
        />

        <!-- showSelectFilter -->
        <transition name="fade">
            <responsive-filter-popup
                v-show="showSelectFilter"
                :originalFilter="originalFilter"
                :compounds="compoundList"
                :auctions="auctions"
                :makes="makes"
                :minPrice="minPrice"
                :maxPrice="maxPrice"
                :maxMileage="maxMileage"
                :minYear="minYear"
                :maxYear="maxYear"
                @filter="filter"
                @clear="clear"
                @close="closeSelectFilter"
            />
        </transition>
    </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

<script>
import FilterLabel from "@/Components/List/FilterLabel";
import SortComponent from "@/Components/List/Sort";
import SelectedFilterComponent from "@/Components/List/SelectedFilter";
import ResponsiveFilterPopup from "@/Components/List/ResponsiveFilterPopup";

export default {
    components: {
        FilterLabel,
        SortComponent,
        SelectedFilterComponent,
        ResponsiveFilterPopup,
    },
    data() {
        return {
            test: false,
            showSelectFilter: false,
        };
    },
    computed: {
        filterLength() {
            let result = 0;

            if (this.originalFilter) {
                for (let key in this.originalFilter) {
                    if (
                        key === "make" ||
                        key === "auction" ||
                        key === "compound"
                    ) {
                        result += this.originalFilter[key].length;
                    } else {
                        result++;
                    }
                }
            }

            if (this.keyword && this.keyword.length > 0) {
                result++;
            }

            return result;
        },
    },
    methods: {
        sort(key) {
            this.$emit("sort", key);
        },
        remove(field, option) {
            this.$emit("remove", field, option);
        },
        selectFilter() {
            this.showSelectFilter = true;
        },
        closeSelectFilter() {
            this.showSelectFilter = false;
        },
        filter(selectedFilter) {
            this.$emit("filter", selectedFilter);
        },
        clear() {
            this.$emit("clear");
        },
    },
    props: {
        isLoaded: {
            type: Boolean,
            default: true,
        },
        total: {
            type: Number,
            default: 0,
        },
        originalSort: {
            type: String,
            default: null,
        },
        keyword: {
            type: String,
            default: null,
        },
        originalFilter: {
            type: Object,
            default: null,
        },
        compoundList: {
            type: Array,
            default: null,
        },
        minPrice: {
            type: Number,
            default: 0,
        },
        maxPrice: {
            type: Number,
            default: 100,
        },
        minYear: {
            type: Number,
        },
        maxYear: {
            type: Number,
        },
        maxMileage: {
            type: Number,
        },
        auctions: {
            type: Array,
            default: null,
        },
        makes: {
            type: Array,
            default: null,
        },
    },
};
</script>
